import React, { useState } from 'react';
import { Shield, Users, Search, Plus, Edit2, Trash2, CheckCircle2, XCircle } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
interface AdminRolesManagerProps {
  success: (msg: string) => void;
  setDetailPanel: (panel: any) => void;
}
export function AdminRolesManager({
  success,
  setDetailPanel
}: AdminRolesManagerProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const roles = [{
    id: 'ROL-001',
    name: 'Super Admin',
    users: 2,
    description: 'Полный доступ ко всем разделам системы',
    isSystem: true
  }, {
    id: 'ROL-002',
    name: 'Manager',
    users: 5,
    description: 'Управление контентом, пользователями и заказами',
    isSystem: true
  }, {
    id: 'ROL-003',
    name: 'Support',
    users: 12,
    description: 'Доступ к чатам, жалобам и базовой информации пользователей',
    isSystem: true
  }, {
    id: 'ROL-004',
    name: 'Content Editor',
    users: 3,
    description: 'Управление блогом и CMS',
    isSystem: false
  }, {
    id: 'ROL-005',
    name: 'Finance Admin',
    users: 1,
    description: 'Доступ только к финансовым отчетам и выплатам',
    isSystem: false
  }];
  const permissions = [{
    category: 'Пользователи',
    items: ['Просмотр', 'Редактирование', 'Блокировка', 'Удаление']
  }, {
    category: 'Астрологи',
    items: ['Просмотр', 'Верификация', 'Редактирование', 'Блокировка']
  }, {
    category: 'Заказы',
    items: ['Просмотр', 'Изменение статуса', 'Возвраты', 'Удаление']
  }, {
    category: 'Финансы',
    items: ['Просмотр', 'Выплаты', 'Настройки шлюзов']
  }, {
    category: 'Контент (CMS)',
    items: ['Просмотр', 'Создание', 'Публикация', 'Удаление']
  }, {
    category: 'Настройки',
    items: ['Просмотр', 'Редактирование системных настроек']
  }];
  const handleEditRole = (role: any) => {
    setDetailPanel({
      type: 'role_full',
      title: `Редактирование роли: ${role.name}`,
      data: {
        role,
        permissions
      }
    });
  };
  return <div className="space-y-6" data-id="element-6907">
      <div className="flex justify-between items-center" data-id="element-6908">
        <div data-id="element-6909">
          <h2 className="text-xl font-bold text-slate-900" data-id="element-6910">Роли и доступы</h2>
          <p className="text-sm text-slate-500" data-id="element-6911">
            Управление правами администраторов системы
          </p>
        </div>
        <Button variant="primary" icon={<Plus className="w-4 h-4" data-id="element-6913" />} data-id="element-6912">
          Создать роль
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-6914">
        {/* Roles List */}
        <div className="lg:col-span-2 space-y-4" data-id="element-6915">
          <Card padding="sm" className="rounded-xl shadow-none border-slate-200" data-id="element-6916">
            <div className="relative" data-id="element-6917">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-6918" />
              <input type="text" placeholder="Поиск ролей..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-indigo-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-6919" />
            </div>
          </Card>

          <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6920">
            <table className="w-full text-left" data-id="element-6921">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6922">
                <tr data-id="element-6923">
                  <th className="px-4 py-3 font-medium" data-id="element-6924">Роль</th>
                  <th className="px-4 py-3 font-medium" data-id="element-6925">Описание</th>
                  <th className="px-4 py-3 font-medium text-center" data-id="element-6926">
                    Пользователи
                  </th>
                  <th className="px-4 py-3 text-right font-medium" data-id="element-6927">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-6928">
                {roles.filter(r => r.name.toLowerCase().includes(searchQuery.toLowerCase())).map(role => <tr key={role.id} className="hover:bg-slate-50" data-id="element-6929">
                      <td className="px-4 py-3" data-id="element-6930">
                        <div className="flex items-center gap-2" data-id="element-6931">
                          <Shield className={`w-4 h-4 ${role.isSystem ? 'text-indigo-500' : 'text-slate-400'}`} data-id="element-6932" />
                          <span className="text-sm font-bold text-slate-900" data-id="element-6933">
                            {role.name}
                          </span>
                          {role.isSystem && <Badge variant="neutral" size="sm" className="text-[9px] py-0 h-4" data-id="element-6934">
                              Системная
                            </Badge>}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6935">
                        {role.description}
                      </td>
                      <td className="px-4 py-3 text-center" data-id="element-6936">
                        <div className="inline-flex items-center gap-1 px-2 py-1 bg-slate-100 rounded-md text-xs font-medium text-slate-700" data-id="element-6937">
                          <Users className="w-3 h-3" data-id="element-6938" /> {role.users}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-right" data-id="element-6939">
                        <div className="flex justify-end gap-2" data-id="element-6940">
                          <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400 hover:text-indigo-600" data-id="element-6942" />} onClick={() => handleEditRole(role)} data-id="element-6941" />
                          {!role.isSystem && <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400 hover:text-rose-600" data-id="element-6944" />} data-id="element-6943" />}
                        </div>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </Card>
        </div>

        {/* Quick Info Sidebar */}
        <div className="space-y-4" data-id="element-6945">
          <Card padding="md" className="rounded-xl shadow-none border-slate-200 bg-indigo-50/50 border-indigo-100" data-id="element-6946">
            <h3 className="text-sm font-bold text-indigo-900 mb-2 flex items-center gap-2" data-id="element-6947">
              <Shield className="w-4 h-4 text-indigo-500" data-id="element-6948" /> О системе ролей
            </h3>
            <p className="text-xs text-indigo-800/80 leading-relaxed mb-4" data-id="element-6949">
              Системные роли (Super Admin, Manager, Support) нельзя удалить, но
              можно редактировать их права. Для специфичных задач создавайте
              кастомные роли.
            </p>
            <div className="space-y-2" data-id="element-6950">
              <div className="flex justify-between text-xs" data-id="element-6951">
                <span className="text-indigo-600" data-id="element-6952">Всего администраторов:</span>
                <span className="font-bold text-indigo-900" data-id="element-6953">23</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-6954">
                <span className="text-indigo-600" data-id="element-6955">Активных сессий:</span>
                <span className="font-bold text-indigo-900" data-id="element-6956">8</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}